// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/.pnpm/registry.npmmirror.com+css-loader@0.28.7/node_modules/css-loader/index.js??ref--0-oneOf-2-1!../../../node_modules/.pnpm/registry.npmmirror.com+postcss-loader@2.0.8/node_modules/postcss-loader/lib/index.js??postcss!../../../node_modules/.pnpm/registry.npmmirror.com+less-loader@4.1.0_less@2.7.3+webpack@3.8.1/node_modules/less-loader/dist/cjs.js!./index.less");
if(typeof content === 'string') content = [[module.id, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = require("!../../../node_modules/.pnpm/registry.npmmirror.com+style-loader@0.19.0/node_modules/style-loader/lib/addStyles.js")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/.pnpm/registry.npmmirror.com+css-loader@0.28.7/node_modules/css-loader/index.js??ref--0-oneOf-2-1!../../../node_modules/.pnpm/registry.npmmirror.com+postcss-loader@2.0.8/node_modules/postcss-loader/lib/index.js??postcss!../../../node_modules/.pnpm/registry.npmmirror.com+less-loader@4.1.0_less@2.7.3+webpack@3.8.1/node_modules/less-loader/dist/cjs.js!./index.less", function() {
			var newContent = require("!!../../../node_modules/.pnpm/registry.npmmirror.com+css-loader@0.28.7/node_modules/css-loader/index.js??ref--0-oneOf-2-1!../../../node_modules/.pnpm/registry.npmmirror.com+postcss-loader@2.0.8/node_modules/postcss-loader/lib/index.js??postcss!../../../node_modules/.pnpm/registry.npmmirror.com+less-loader@4.1.0_less@2.7.3+webpack@3.8.1/node_modules/less-loader/dist/cjs.js!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./src/pages/nomatch/index.less
// module id = 189
// module chunks = 20